import { render } from "./Service2.vue?vue&type=template&id=43225598"
import script from "./Service2.vue?vue&type=script&lang=js"
export * from "./Service2.vue?vue&type=script&lang=js"
script.render = render

export default script